import { object, string } from "yup";

export const NewDeliveryTypeSchema = object({
  name: string().required("Задолжително"),
});
